import { OwnersFieldsFragment } from '@api/gql/graphql';
import { Avatar, Chip, Stack } from '@mui/material';
import { OtherTags } from '@common/components/OtherTags';
import { getFragmentData } from '@api/gql';
import { INTEGRATION_FRAGMENT } from '@AccessRightSizing/services/gql';

export function ResourceOwnersChips({ owners }: { owners: OwnersFieldsFragment[] }) {
  const ownersSliced = owners.slice(0, 3);
  const otherOwners = owners
    .slice(3)
    .map((otherOwner) => `${otherOwner.attributeValue.type}:  <strong>{otherOwner.tagName}</strong>`);

  return (
    <Stack direction="row" spacing={0.5}>
      {ownersSliced.map((owner) => {
        const { icons } = getFragmentData(INTEGRATION_FRAGMENT, owner.integration) || {};
        return (
          <Chip
            key={owner.attributeValue.typDisplayName}
            label={
              <>
                {`${owner.attributeValue.typDisplayName}:`} <strong>{owner.attributeValue.name}</strong>
              </>
            }
            icon={<Avatar src={icons?.svg} sx={{ width: 16, height: 16 }} />}
            size="small"
            variant="outlined"
          />
        );
      })}
      {otherOwners.length > 0 && <OtherTags tags={otherOwners} />}
    </Stack>
  );
}
